module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 11.f0906d14.png";